export default {
    // 'delete-message-penalty': 'Are you sure you want to delete the penalty?',
    // 'delete-message-bonus': 'Are you sure you want to delete the bonus?'
};
